module.exports = __webpack_public_path__ + "static/tour_pic.ca3fa77d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tour_pic.jpg
// module id = 3222
// module chunks = 174994552580003